<template>
	<div style="height: 100%; width: 100%;position: relative">
		<div class="hea">
			<!-- <img src="../../assets/logo.png" alt="" style="width: 30px; height: 30px; "/> -->
			<div v-show="!Collapse" class="title">家属用电预付费</div>
		</div>
		<!-- <el-header>
			<strong style="font-size: 25px; float: left; color: white;">{{ userInfo.unitname }}</strong>

			<div class="header-avatar">

				<el-avatar size="medium" :src="require('@/assets/logo.png')"></el-avatar>

				<el-dropdown>
					<span class="el-dropdown-link" style="color: white;">
					{{ userInfo.nickname }}<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item>
							<router-link :to="{name: 'UserCenter'}">个人中心</router-link>
						</el-dropdown-item>
						<el-dropdown-item @click.native="logout">退出</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>

		</el-header> -->

		<el-menu
				:default-active="this.$store.state.menus.editableTabsValue"
				class="el-menu-vertical-demo"
				background-color="white"
				text-color="black"
				unique-opened
				:collapse="Collapse"
				active-text-color="#11A983">

			<router-link to="/index">
				<el-menu-item index="Index"  @click="selectMenu({name: 'Index', title: '首页'})">
					<!-- <template slot="title"> -->
						<i class="el-icon-s-home"></i>
						<span slot="title">首页</span>
					<!-- </template> -->
				</el-menu-item>
			</router-link>

			<el-submenu :index="menu.name" v-for="(menu,i) in menuList" :key="i">
				<template slot="title">
					<!-- <i :class="menu.icon"></i> -->
					<i class="el-icon-s-unfold"></i>
					<span>{{menu.title}}</span>
				</template>
				<router-link :to="item.path" v-for="(item, it) in menu.children" :key="it">
					<el-menu-item :index="item.name" @click="selectMenu(item)">
						<template slot="title">
							<!-- <i :class="item.icon"></i> -->
							<i class="el-icon-mobile"></i>
							<span slot="title">{{item.title}}</span>
						</template>
					</el-menu-item>
				</router-link>
			</el-submenu>

			<router-link to="/userCenter">
				<el-menu-item index="UserCenter"  @click="selectMenu({name: 'UserCenter', title: '个人中心'})">
					<!-- <template slot="title"> -->
						<i class="el-icon-user-solid"></i>
						<span slot="title">个人中心</span>
					<!-- </template> -->
				</el-menu-item>
			</router-link>

		</el-menu>

		<div class="footerIcon">
			<div class="icon" :class="Collapse?'coll':''" title="收起/展开菜单" @click="CollapseMenu">
				<i v-if="!Collapse" class="el-icon-s-fold" style="font-size: 30px; line-height: 40px; font-weight: 500; color: var(--color-primary)"></i>
				<i v-if="Collapse" class="el-icon-s-unfold" style="font-size: 30px; line-height: 40px; font-weight: 500; color: var(--color-primary)"></i>
			</div>
			<div v-show="!Collapse" class="img" @click="logout" title="退出登录">
				<img src="../../assets/tui2.png" style="height: 30px;" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "SideMenu",
		props: {
			Collapse: Boolean
		},
		data() {
			return {
			}
		},
		computed:  {
			menuList: {
				get() {
					return this.$store.state.menus.menuList
				}
			}
		},
		methods: {
			selectMenu(item) {
				this.$store.commit("addTab", item)
			},
			CollapseMenu() {
				this.$emit('CollapseMenu')
			},
			logout() {
				this.$confirm('确定退出系统吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.post("/logout").then(res => {
						localStorage.clear()
						sessionStorage.clear()
						this.$store.commit("resetState")
						this.$router.push("/login")
					})
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// })
				})
			}
	
		}
	}
</script>

<style scoped>
	.el-menu-vertical-demo {
		height: calc(100% - 100px);
		position: relative;
		box-shadow: 2px 0 6px rgba(0, 21, 41, .35);
	}

	.router-link-active {
		text-decoration: none;
	}
	a {
		text-decoration: none;
	}
	.el-menu-item {
		/* min-width: 194px !important; */
	}
	.el-menu-item:hover, .el-submenu /deep/.el-submenu__title:hover {
		background-color: #b7e7db !important;
	}
	.el-menu-item.is-active {
		background-color: #b7e7db !important;
	}

	.hea {
		height: 60px;
		width: 100%;
		color: white;
		background-color: var(--color-primary);
		z-index: 1000;
		position: relative;
		line-height: 60px;

		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		/* justify-content: space-around; */
	}
	.hea .title {
		color: white;
		font-size: 18px;
		font-weight: 700;
		text-align: center;
	}
	.footerIcon {
		position: relative; 
		line-height: 40px !important;
		height: 40px;
		background: white;
		width: 100%;

		display: flex;
		align-items: center;
		flex-direction: row;
		justify-content: space-between;
	}
	.footerIcon div {
		height: 40px;
		width: 50%;
		cursor: pointer;

		display: flex;
		align-items: center;
		justify-content: center;
	}
	.footerIcon .coll {
		height: 40px;
		width: 100%;
		cursor: pointer;

		display: flex;
		align-items: center;
		justify-content: center;
	}
	.footerIcon .icon:hover, .footerIcon .img:hover{
		background: #b7e7db;
	}
</style>